import { FEATURE_NAME } from './constants';
import { createSlice } from '@reduxjs/toolkit';
import * as T from './types';
import * as actions from './actions';

const initialState: T.SitesState = {
  error: null,
  loading: false,
  sites: null,
};

export const sitesSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(actions.fetchAllUserSites.fulfilled, (state, action) => {
      state.sites = action.payload.data;
      state.error = null;
      state.loading = false;
    });
    builder.addCase(actions.fetchAllUserSites.rejected, (state, action) => {
      state.sites = null;
      state.error = action.error.message;
      state.loading = false;
    });
    builder.addCase(actions.fetchAllUserSites.pending, (state) => {
      state.sites = null;
      state.error = null;
      state.loading = true;
    });
  },
});
